import { fotos } from "./martos/galeria";
require('../sass/proyecto.scss');
fotos('.proyecto__plano');
